import { Close } from '@material-ui/icons'
import React from 'react'

import * as Styled from './styled'

export interface ConfirmationModalProps {
  cancelButtonText?: React.ReactElement
  children?: React.ReactNode
  className?: string
  confirmButtonText?: React.ReactElement
  description: string
  disabled?: boolean
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
  title: string
}

const doNothing = () => {
  // intentionally empty body
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  cancelButtonText = 'Cancel',
  children,
  className,
  confirmButtonText = 'Ok',
  description,
  disabled = false,
  isOpen,
  onCancel,
  onConfirm,
  title,
}) => {
  return (
    <Styled.Dialog className={className} open={isOpen} onClose={disabled ? doNothing : onCancel}>
      <Styled.ModalContainer>
        <Styled.ModalHeader>
          <Styled.ModalTitle>{title}</Styled.ModalTitle>
          <Styled.ModalCloseButton disabled={disabled} onClick={onCancel}>
            <Close />
          </Styled.ModalCloseButton>
        </Styled.ModalHeader>
        <Styled.ModalContent>
          <Styled.ModalText>{description}</Styled.ModalText>
          {children}
          <Styled.ModalButtons>
            <Styled.ModalYesButton disabled={disabled} onClick={onConfirm}>
              {confirmButtonText}
            </Styled.ModalYesButton>
            <Styled.ModalNoButton disabled={disabled} onClick={onCancel}>
              {cancelButtonText}
            </Styled.ModalNoButton>
          </Styled.ModalButtons>
        </Styled.ModalContent>
      </Styled.ModalContainer>
    </Styled.Dialog>
  )
}
